import { jwtDecode } from "jwt-decode";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { LOCALSTORAGE_KEYS } from "@/config";

interface JwtPayload {
  name: string;
  role: string;
  id: string;
  tenantid: string;
}

interface AuthState {
  setName: (value: string) => void;
  isAuthenticated: boolean;
  setIsAuthenticated: (value: boolean) => void;
  logout: () => void;
  userName: string;
  setUserName: (value: string) => void;
  id: string;
  setId: (value: string) => void;
  role: string;
  setRole: (value: string) => void;
  tenantid: string;
  setTenantId: (value: string) => void;
  userEmail: string;
  setUserEmail: (value: string) => void;
  userImg: string;
  setUserImg: (value: string) => void;
  companyName: string;
  setCompanyName: (value: string) => void;
}

const token = localStorage.getItem(LOCALSTORAGE_KEYS.token);
let initialName = "";
let initialRole = "";
let initialId = "";
let initialTenantid = "";
const initialEmail = "";
const initialUserImg = "";
const initialCompanyName = "";

if (token) {
  try {
    const { name, role, id, tenantid } = jwtDecode<JwtPayload>(token);
    initialName = name;
    initialRole = role;
    initialId = id;
    initialTenantid = tenantid;
  } catch {
    console.warn("Invalid JWT token format");
  }
}

const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: Boolean(localStorage.getItem(LOCALSTORAGE_KEYS.token)),
      userName: initialName,
      companyName: initialCompanyName,
      role: initialRole,
      id: initialId,
      userEmail: initialEmail,
      userImg: initialUserImg,
      setIsAuthenticated: (value) => set({ isAuthenticated: value }),
      setUserName: (value) => set({ userName: value }),
      setCompanyName: (value) => set({ companyName: value }),
      setRole: (value) => set({ role: value }),
      setId: (value) => set({ id: value }),
      setUserImg: (value) => set({ userImg: value }),
      setUserEmail: (value) => set({ userEmail: value }),
      setName: (value: string) => set({ userName: value }),
      logout: () => {
        localStorage.removeItem(LOCALSTORAGE_KEYS.token);
        localStorage.removeItem(LOCALSTORAGE_KEYS.refreshToken);
        localStorage.removeItem("auth_token");
        localStorage.removeItem("tenantId");
        localStorage.removeItem("user-store");
        localStorage.removeItem("Details-store");
        set({
          isAuthenticated: false,
          userName: "",
          companyName: "",
          role: "",
          id: "",
          userEmail: "",
          userImg: "",
          tenantid: "",
        });
      },
      tenantid: initialTenantid,
      setTenantId: (value) => set({ tenantid: value }),
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        userName: state.userName,
        role: state.role,
        id: state.id,
      }),
    },
  ),
);

export default useAuthStore;
